<template>
<div class="row" v-show="!isSingleUser">
   <div class="col-14">Voorkeur behandelaar?</div>
   <div class="col-10"><a  @click="selectUser" style="color:#ee0000;text-decoration: underline">{{this.selUser.UserName}}</a></div>
   <div class="col-lg-24" style="height:10px">&nbsp;</div>
</div>
</template>

<style>

.left{
 float: left; 
 height: 120px;
}

.internal{

 height: 100%;
 display: inline-block;
}

.center{
 float: left; 
 height: 120px;
 overflow: hidden;
 white-space: nowrap;
}

.right{
 float: right; 
 height: 120px;
}

</style>

<script>
import CartItemUser from './CartItemUser';
import myHttpApi from "../../api/myhttpapi";
import {
    SPINNER_SHOW,
    SPINNER_HIDE
  } from '../../store/mutation-types'

  export default {
    props: ['product'],
    data () {
      return {
        cart: this.$store.state.cart,
        users : [],
        selUser : {},
        flgShowUsers : false,
        isSingleUser : true
      }
    },
    components: {
       CartItemUser
    },
    mounted () {
      this.selUser = {UserName : '?', UserID: ''};
      this.loadUsers ();
    },
    computed: {
    },
    methods: {
      selectUser () {
        
        this.$emit('user-select-forprod', this, this.product, this.users);
      },
      setUser (user) {
        this.selUser  = user
      },
      loadUsers () {
          this.$store.commit(SPINNER_SHOW);
          this.selUser  = {UserName : '?', UserID: ''};
          this.isSingleUser = true;
          const searchRec = {Search: this.product.ArticleID, Extra: ""}
          myHttpApi.post( 'Service/ServiceUsers', searchRec)
              .then(response => {
                this.users = response.data
                if (this.users.length > 1) 
                {
                   this.isSingleUser = false;
                   this.selUser = this.users[0];
                   if (this.product.SelectedUserID != undefined)
                   {
                      //console.log ("Selected user for this :" + this.product.SelectedUserID);
                      for (var u = 0; u < this.users.length; u++)
                      {
                          if (this.users[u].UserID == this.product.SelectedUserID)
                          {
                             this.selUser = this.users[u];
                             break;
                          }
                      }
                   }
                }
                this.$store.commit(SPINNER_HIDE);
              })
              .catch(error => {
                console.log(error);
                this.$store.commit(SPINNER_HIDE);
          });
          
      },
      scrollTo(element, scrollPixels, duration) {
        const scrollPos = element.scrollLeft;
        // Condition to check if scrolling is required
        if ( !( (scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) 
        {
          // Get the start timestamp
          const startTime =
            "now" in window.performance
              ? performance.now()
              : new Date().getTime();
          
          function scroll(timestamp) {
            //Calculate the timeelapsed
            const timeElapsed = timestamp - startTime;
            //Calculate progress 
            const progress = Math.min(timeElapsed / duration, 1);
            //Set the scrolleft
            element.scrollLeft = scrollPos + scrollPixels * progress;
            //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
            if (timeElapsed < duration) {
              //Request for animation
              window.requestAnimationFrame(scroll);
            } else {
              return;
            }
          }
          //Call requestAnimationFrame on scroll function first time
          window.requestAnimationFrame(scroll);
        }
      },
      swipeLeft() {
        const content = this.$refs.contentUser;
        this.scrollTo(content, -300, 800);
      },
      swipeRight() {
        const content = this.$refs.contentUser;
        this.scrollTo(content, 300, 800);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/cart/CartItemUserLst.vue